export const theme = {
    color: {
        mercury: "#E5E5E5",
        whisper: "#F5F5FA",
        white: "#FFFFFF",
        black: "#000000",
        lightBlack: "#18181B",
        blue: "#0044CC",
        blueRibbon: "#0055FF",
        lightBlue: "#D6E4FF",
        grey: "#E4E6F0",
        darkerGrey: "#7E839A",
        stormGrey: "#74788B",
        silver: "#C4C4C4",
    },

    breakpoint: {
        mediumScreen: 1280,
        smallScreen: 991,
        mobileMax: 767,
        mobileMin: 320,
    }
};